<template>
  <v-dialog eager v-model="dlgModel" width="80%" @close="onClose()">
    <v-card>
      <v-container>
        <canvas ref="barChart"></canvas>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<style lang="css">

</style>

<script>
import Chart from 'chart.js';
import persistentStorage from "@/services/PersistentStorage";

export default {
  name: 'LinkStatistics',
  data: () => ({
    chart: null,
    year: null,
    month: null
  }),
  props: {
    link: Object,
    value: Boolean
  },
  computed: {
    dlgModel: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    updateChart() {
      persistentStorage.getObject('links/' + this.link.id + '/stat', this.year.toString() + this.month.toString().padStart(2, '0')).then(
          function(result) {
            let date = new Date(this.year, this.month - 1, 1);
            let labels = [];
            let numCalls = [];
            let resultIndex = 0;
            const dayNames = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
            while(date.getMonth() == this.month - 1) {
               labels.push(date.getDate() + ' ' + dayNames[date.getDay()]);

               // if(resultIndex < result.length)
               //   console.log(result[resultIndex].date, date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0'));
               if(resultIndex < result.length && result[resultIndex].date == date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0')) {
                 numCalls.push(result[resultIndex].count);
                 resultIndex++;
               } else {
                 numCalls.push(0);
               }
               // console.log(numCalls);
               date.setDate(date.getDate() + 1);
            }
            this.chart.data.labels = labels;
            this.chart.data.datasets[0].data = numCalls;
            this.chart.update();
          }.bind(this),
          function(error) {
            console.log(error);
          }
      )
    },
    onClose() {
      console.log('close');
      this.link = null;
    }
  },
  watch: {
    link() {
      this.updateChart();
    },
    value() {
      this.updateChart();
    }
  },
  mounted() {
    const ctx = this.$refs.barChart;

    this.chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: [],
        datasets: [{
          label: 'Aufrufe',
          data: [],
          borderWidth: 1
        }]
      },
      options: {
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
    });

    let date = new Date();
    this.year = date.getFullYear();
    this.month = date.getMonth() + 1;
  }
}

</script>